'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from 'react';
import { isLighthouseClient } from '@/lib/isLighthouse';
declare global {
  interface Window {
    _izq: any[];
    izootoLoaded?: boolean;
  }
}

/**
 * IZooto Push Notifications - Deferred Loading
 * Loads the iZooto script only after user interaction or scroll to reduce initial JS load
 */
export default function IZootoInit() {
  const $ = _c(2);
  const loadedRef = useRef(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      if (isLighthouseClient()) {
        return;
      }
      const loadIZooto = () => {
        if (loadedRef.current || window.izootoLoaded) {
          return;
        }
        loadedRef.current = true;
        window.izootoLoaded = true;
        window._izq = window._izq || [];
        window._izq.push(["init"]);
        const script = document.createElement("script");
        script.src = "https://cdn.izooto.com/scripts/7971c6cc7b16acf3f079c3b680f77fee91d3232a.js";
        script.async = true;
        document.head.appendChild(script);
        script.onload = _temp2;
      };
      const timer = setTimeout(loadIZooto, 10000);
      const events = ["scroll", "click", "touchstart"];
      const handleInteraction = () => {
        clearTimeout(timer);
        setTimeout(loadIZooto, 100);
      };
      events.forEach(event => {
        document.addEventListener(event, handleInteraction, {
          once: true,
          passive: true
        });
      });
      return () => {
        clearTimeout(timer);
        events.forEach(event_0 => {
          document.removeEventListener(event_0, handleInteraction);
        });
      };
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  return null;
}
function _temp2() {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.register("/service-worker.js", {
      scope: "/"
    }).catch(_temp);
  }
}
function _temp() {}